import React from 'react';

import Spinner from 'react-bootstrap/Spinner';

import Container from 'react-bootstrap/Container';
import PoweredBy from '../Component/General/PoweredBy';

interface Props {
    amountRequests?: number;
}

const LoadingPage: React.FC<Props> = ({ amountRequests }: Props) => (
    <>
        <Container className="loading-container">
            <div className="loading-container__loading">
                <h2>Gegevens ophalen</h2>
                <div className="loading-container__loading__spinner">
                    <Spinner animation="border" />
                    {typeof amountRequests !== 'undefined' && (
                        <span className="loading-container__loading__spinner__amount-retries">{amountRequests}</span>
                    )}
                </div>
                <strong>We halen nu de juiste data op</strong>
            </div>
        </Container>
        <PoweredBy />
    </>
);

export default LoadingPage;
